import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../firebase';

const DEFAULT_ORDER = [
  'hero',
  'growth',
  'alert',
  'appointments',
  'metrics',
  'winRate',
  'trend',
  'insights',
  'activity',
  'bonus',
  'recentSales',
];

export async function loadDashboardOrder(uid) {
  try {
    const ref = doc(db, 'users', uid, 'settings', 'dashboardOrder');
    const snap = await getDoc(ref);
    if (snap.exists() && snap.data().order) {
      const saved = snap.data().order;
      const merged = [
        ...saved.filter(id => DEFAULT_ORDER.includes(id)),
        ...DEFAULT_ORDER.filter(id => !saved.includes(id)),
      ];
      return merged;
    }
  } catch (e) {
    console.warn('Could not load dashboard order:', e);
  }
  return DEFAULT_ORDER;
}

export async function saveDashboardOrder(uid, order) {
  try {
    const ref = doc(db, 'users', uid, 'settings', 'dashboardOrder');
    await setDoc(ref, { order }, { merge: true });
  } catch (e) {
    console.warn('Could not save dashboard order:', e);
  }
}

export { DEFAULT_ORDER };
